export const UI_SHOW_LIST = 'UI_SHOW_LIST';
export const UI_SHOW_SIDEBAR = 'UI_SHOW_SIDEBAR';
export const UI_SHOW_SNACKBAR = 'UI_SHOW_SNACKBAR';
export const UI_SNACKBAR_CLEAR = 'UI_SNACKBAR_CLEAR';
